<template>
    <div class="position-box">
      <div class="cotainer">
        <!-- <div class="user-head">
          <img class="logo" src="@/assets/new4/logo.png" alt="">
          <div class="title">Blkketf</div>
          <img class="close" @click="backIndex" src="@/assets/new4/close.png" alt="">
        </div> -->
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="backIndex" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="backIndex" alt="">
            <div class="title"></div>
        </div>
        <div class="user-btn-box" v-show="!token">
          <div class="user-btn btn-login buttbg" @click="jumpUrl('/login')">{{$t('lg.lgbt')}}</div>
          <div class="user-btn btn-reg" @click="jumpUrl('/reg')">{{$t('lg.register')}}</div>
        </div>
        <div class="user-wrap" v-show="token" @click="toSet">
          <img class="img" :src="'/static/logo/logo1-v'+Tversion+'.png'">
          <div class="user-box">
            <div class="account" v-if="userName">{{userName.length>32?userName.substr(0,4)+'***'+userName.substr(-8):userName | mdName}}</div>
            <div class="uid">(UID {{userID}})</div>
          </div>
          <img class="arrow" src="@/assets/new/jiantou2.png" alt="">
        </div>
        <div class="user-tips">{{$t('user.zcgl')}}</div>
        <ul class="user-ul">
          <li class="user-li" @click="jump('deposit')">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/Deposit.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/chongbi.png" alt="" v-else>
            </div>
            <div class="text">{{$t('chongzhi.title')}}</div>
          </li>
          <li class="user-li" @click="jump('withdraw')">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/Withdrawals.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/tibi.png" alt="" v-else>
            </div>
            <div class="text">{{$t('tibi.title')}}</div>
          </li>
          <li class="user-li" tag="li" @click="jumpUrl('subscription')">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/Sgd.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/xinbi.png" alt="" v-else>
            </div>
            <div class="text">{{$t('user.xb')}}</div>
          </li>
          <li class="user-li" tag="li" @click="jumpUrl('/currency')">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/Credits.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/daibi.png" alt="" v-else>
            </div>
            <div class="text">{{$t('wydb.db')}}</div>
          </li>
          <template v-if="Tversion == 3">
            <router-link class="user-li" tag="li" to="/accountRecords">
              <div class="icon-box"><img class="icon" src="@/assets/new4/jilu.png" alt=""></div>
              <div class="text">{{$t('wydb.jl')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/credit">
              <div class="icon-box"><img class="icon" src="@/assets/new4/xinyong.png" alt=""></div>
              <div class="text">{{$t('xyf.title')}}</div>
            </router-link>
            <div class="user-li" @click="service">
              <div class="icon-box"><img class="icon" src="@/assets/new4/kefu.png" alt=""></div>
              <div class="text">{{$t('user.kf')}}</div>
            </div>
          </template>
          <template v-else>
            <li class="user-li" tag="li" @click="jumpUrl('/propagate')">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/Earn-coins.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/AIzhuanbi.png" alt="" v-else>
              </div>
              <div class="text" v-if="Tversion==3" >{{$t('矿池赚币')}}</div>
              <div class="text" v-else>{{$t('bzhl.title')}}</div>
            </li>
            <li class="user-li" tag="li" @click="jumpUrl('/contractTransaction')">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/jiaoyi1.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/jiaoyi.png" alt="" v-else>
              </div>
              <div class="text">{{$t('langNew.jy')}}</div>
            </li>
          </template>
          <!-- <li class="user-li" tag="li" @click="jumpUrl('/IEO')" v-if="Tversion!=3">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/IEO.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/ieo.png" alt="" v-else>
            </div>
            <div class="text">IEO</div>
          </li> -->
          <template v-if="Tversion!=3">
            <li class="user-li" tag="li" @click="createDemo" v-if="isdemo == 2">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/monijiaoyi.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/monijiaoyi@2x.png" alt="" v-else>
              </div>
              <div class="text">{{$t('模拟交易')}}</div>
            </li>
            <li class="user-li" tag="li" @click="loginOut" v-else>
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/monijiaoyi.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/monijiaoyi@2x.png" alt="" v-else>
              </div>
              <div class="text">{{$t('关闭模拟')}}</div>
            </li>
          </template>
        </ul>
        <div class="user-tips">{{$t('user.hd')}}</div>
        <ul class="user-ul">
          <router-link class="user-li" tag="li" to="/sign" v-if="Tversion==4">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/qiandao.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/qiandao.png" alt="" v-else>
            </div>
            <div class="text">{{$t('langNew2.qd')}}</div>
          </router-link>
          <router-link class="user-li" tag="li" to="/benefits" v-if="Tversion ==5">
            <div class="icon-box"><img class="icon" src="@/assets/new4/fuli.png" alt=""></div>
            <div class="text">{{$t('langNew4.flhd')}}</div>
          </router-link>
          <template v-if="Tversion==1">
            <router-link class="user-li" tag="li" to="/benefits">
              <div class="icon-box"><img class="icon" src="@/assets/new4/fuli.png" alt=""></div>
              <div class="text">{{$t('langNew4.flhd')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/share">
              <div class="icon-box"><img class="icon" src="@/assets/new4/yaoqing.png" alt=""></div>
              <div class="text">{{$t('wdtg.yq')}}</div>
            </router-link>
          </template>
          <template v-if="Tversion==3">
            <router-link class="user-li" tag="li" to="/benefits">
              <div class="icon-box"><img class="icon" src="@/assets/new4/fuli.png" alt=""></div>
              <div class="text">{{$t('langNew4.flhd')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/notice2">
              <div class="icon-box"><img class="icon" src="@/assets/tixing-gray.png" alt=""></div>
              <div class="text">{{$t('公告')}}</div>
            </router-link>
          </template>
        </ul>
        <div class="user-tips">{{$t('user.zhxg')}}</div>
        <ul class="user-ul">
          <template v-if="Tversion == 3">
            <router-link class="user-li" tag="li" to="/authentication">
              <div class="icon-box">
                <img class="icon" src="@/assets/new4/shenfen.png" alt="">
              </div>
              <div class="text">{{$t('user.sfrz')}}</div>
            </router-link>
            <li class="user-li" tag="li" @click="jumpUrl('/propagate')">
              <div class="icon-box"><img class="icon" src="@/assets/new4/AIzhuanbi.png" alt=""></div>
              <div class="text" v-if="Tversion==3" >{{$t('矿池赚币')}}</div>
              <div class="text" v-else>{{$t('bzhl.title')}}</div>
            </li>
            <li class="user-li" tag="li" @click="jumpUrl('/preciousMetal')">
              <div class="icon-box"><img class="icon" src="@/assets/new4/jiaoyi.png" alt=""></div>
              <div class="text">{{$t('langNew.jy')}}</div>
            </li>
          </template>
          <template v-else>
            <div class="user-li" @click="service">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/kefu.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/kefu.png" alt="" v-else>
              </div>
              <div class="text">{{$t('user.kf')}}</div>
            </div>
            <router-link class="user-li" tag="li" to="/authentication">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/shenfen.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/shenfen.png" alt="" v-else>
              </div>
              <div class="text">{{$t('user.sfrz')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/records?type=0" v-if="TemplateType == 1">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/jilu.png" alt="">
              </div>
              <div class="text">{{$t('wydb.jl')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/accountRecords" v-else>
              <div class="icon-box">
                <img class="icon" src="@/assets/new4/jilu.png" alt="">
              </div>
              <div class="text">{{$t('wydb.jl')}}</div>
            </router-link>
            <router-link class="user-li" tag="li" to="/credit">
              <div class="icon-box">
                <img class="icon" src="@/assets/temp1/xinyong.png" alt="" v-if="TemplateType == 1">
                <img class="icon" src="@/assets/new4/xinyong.png" alt="" v-else>
              </div>
              <div class="text">{{$t('xyf.title')}}</div>
            </router-link>
          </template>
          <router-link class="user-li" tag="li" to="/securityCenter">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/anquan.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/anquan.png" alt="" v-else>
            </div>
            <div class="text">{{$t('user.aq')}}</div>
          </router-link>
          <router-link class="user-li" tag="li" to="/about">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/guanyu.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/guanyu.png" alt="" v-else>
            </div>
            <div class="text">{{$t('user.gy')}}</div>
          </router-link>
          <router-link class="user-li" tag="li" to="/set">
            <div class="icon-box">
              <img class="icon" src="@/assets/temp1/shezhi.png" alt="" v-if="TemplateType == 1">
              <img class="icon" src="@/assets/new4/shezhi.png" alt="" v-else>
            </div>
            <div class="text">{{$t('user.sz')}}</div>
          </router-link>
        </ul>
      </div>
        <!-- <nav-bar :navName="'user'"></nav-bar> -->
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'user',
    data () {
        return {
            theme: false,
            token: '',
            userName: '',
            userID: '',
            money: '',
            isSmrz: 0,
            isCjrz: 0,
            isGjrz: 0,
            isDzrz: 0,
            isCredit: 0,
            name_auth_status: 0,
            base_auth_status: 0,
            address_auth_status: 0,
            service_link: '',
            isPwd: false,
            lang: 'en',
            account:'',
            isdemo:2,
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.token = localStorage.getItem('token');
      this.theme = JSON.parse(localStorage.getItem('theme'));
      // this.isPwd = JSON.parse(localStorage.getItem('isPwd'));
      this.lang = localStorage.getItem('language') || 'en';
      if(this.token){
        this.userName = localStorage.getItem('userName');
        this.userID = localStorage.getItem('uid');
        this.getInfo();
      }
      let data1 = localStorage.getItem('demoType');
      if(data1){
        this.isdemo = data1;
      }
    },
    mounted() {
    },
    methods: {
      backIndex(){
        this.$router.go(-1);
      },
      toSet(){
        this.$router.push('/set');
      },
      getInfo(){
        this.$ajax.get('/web/info',{}).then((res) => {
          if(res.data.code == 0){
            let resData = res.data.data;
            if(resData && resData.id){
              this.userName = resData.name;
              this.userID = resData.id;
              localStorage.setItem('userName',this.userName);
              localStorage.setItem('uid',this.userID);
              this.getParams();
              this.getAsset();
              this.getCenterLevel();
              this.getRenzheng();
            }else{
              this.$router.push('/login');
            }
          }
        }).catch(function(err){
            console.log(err)
        })
      },
       getAsset(){
           this.$ajax.get('/web/getAsset2',{}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                this.money = (Number(resData.totalMoney)).toFixed(4);
            }).catch(function(err){
                console.log(err)
            })
       },
       getCenterLevel(){
           this.$ajax.get('/web/getCenterLevel',{level:1}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                this.name_auth_status = resData.name_auth_status;
                this.base_auth_status = resData.base_auth_status;
                this.address_auth_status = resData.address_auth_status;
            }).catch(function(err){
                console.log(err)
            })
       },
       getParams(){
           this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
                let resData = res.data.data;
                this.service_link = resData.filter((item) =>{
                    if(item.key == 'online_service'){
                        return item
                    }
                })[0].value;

                let keys = 'b7062977a00ae39bfd43ffe215e54684';
                let online = this.service_link;
                if(this.token){
                  let uid = localStorage.getItem('uid');
                  let account = localStorage.getItem('account');
                  let agentId = localStorage.getItem('agentId');
                  let data1 = {}
                  let urls = '';
                  data1 = {
                    uid:uid,
                    name:account
                  }
                  if(data1.uid){
                    urls = online+'&userInfo='+encodeURIComponent(JSON.stringify(data1));
                  }else{
                    urls = online;
                  }
                  this.service_link = urls;
                }

            }).catch(function(err){
                console.log(err)
            })
       },
       getRenzheng(){
            this.$ajax.get('/web/has_renzheng',{}).then((res) => {
                let resData = res.data.data;
                this.isSmrz = resData.level;
                this.isCjrz = resData.level1;
                this.isGjrz = resData.level2;
                this.isDzrz = resData.level3;
                this.isCredit = resData.credit;
                localStorage.setItem("signature",resData.signature);
            }).catch(function(err){
                console.log(err)
            })
       },
       // change(){
       //      this.isPwd = !this.isPwd;
       //      localStorage.setItem('isPwd',this.isPwd);
       //      if (this.isPwd) {
       //          this.$refs.input.type = "password"
       //      }else{
       //          this.$refs.input.type = "text"
       //      }
       //  },
        jumpUrl(url){
            this.$router.push({ path: url })
        },
        jump(url){
            if(url == "deposit"){
                this.$router.push({ path: '/selectCurrency', query: { type: 1,url: url } })
            }else{
                this.$router.push({ path: '/selectCurrency', query: { type: 1,url: url } })
            }
        },
        link(id){
            if(id == 0){
                this.$router.push('/authentication')
            }else if(id == 1){
                this.$router.push('/primaryCertification')
            }else if(id == 2){
                this.$router.push('/advancedCertification')
            }else{
                this.$router.push('/addressAuth')
            }
        },
        service(){
          if(!this.service_link) return;
          // window.open(this.service_link)
          this.$router.push({ path: '/service', query: { url: this.service_link } })
          // console.log(this.service_link);
        },
        createDemo(){
          let params = {
                token:1,
            }
            this.$ajax.get('/web/tempLogin',{params}).then((res) => {
              let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    localStorage.setItem('token',resData.data.token);
                    localStorage.removeItem('sbsxbz');
                    localStorage.removeItem('sbsxIcon');
                    setTimeout(() => {
                      if(this.isdemo == 2){
                        this.isdemo = 1;
                      }else{
                        this.isdemo = 2;
                      }
                      localStorage.setItem('demoType',this.isdemo);
                      this.$router.go(0);
                    }, 500)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        loginOut(){
             localStorage.removeItem('token');
             localStorage.removeItem('area_code');
             localStorage.removeItem('city_code');
             localStorage.removeItem('bz');
             localStorage.removeItem('type');
             localStorage.removeItem('tim');
             localStorage.removeItem('type');
             localStorage.removeItem('sbsxbz');
             localStorage.removeItem('sbsxIcon');
             localStorage.removeItem('demoType');
             this.$router.push('/login')
        }
    },
    components:{
        navBar,
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
  .head{
      position: fixed;
      top: 0;
      width: 100%;
      height: 1.6rem;
      padding: 0 .44rem;
      color: #000;
      line-height: 1.6rem;
      background: #fff;
      box-sizing: border-box;
      text-align: center;
  }
  .head .back{
      position: absolute;
      left: .2rem;
      top: 50%;
      width: .4rem;
      margin-top: -.4rem;
  }
  .head .title{
      font-size: .56rem;
  }
  .head .text{
      font-size: .48rem;
  }
  .cotainer{
    position: absolute;
    left: .48rem;
    right: .48rem;
    top: .8rem;
    bottom: 0;
    padding-bottom: 1rem;
    overflow-y: scroll;
  }
  .user-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .3rem 0;
  }
  .user-head .logo{
    width: .82rem;
  }
  .user-head .title{
    flex: 1;
    margin-left: .25rem;
    color: #eee;
    font-size: .58rem;
  }
  .user-head .close{
    width: .52rem;
  }
  .user-btn-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .user-btn-box .user-btn{
    width: 4.62rem;
    height: 1.26rem;
    margin-top: 1.5rem;
    color: #000;
    font-size: .56rem;
    line-height: 1.26rem;
    background: #383838;
    border-radius: 0.14rem;
    text-align: center;
  }
  .user-btn-box .user-btn.btn-reg{
    color: #000;
    background: #fff;
  }
  .user-btn-box .btn-login{color: #fff;}
  .user-wrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0 .3rem;
  }
  .user-wrap .img{
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 50%;
  }
  .user-wrap .user-box{
    flex: 1;
    margin-left: .4rem;
  }
  .user-wrap .account{
    color: #000;
    font-size: .56rem;
  }
  .user-wrap .uid{
    margin-top: .25rem;
    color: #000;
    font-size: .42rem;
  }
  .user-wrap .arrow{
    width: .4rem;
  }
  .user-tips{
    padding: 1.2rem 0 .08rem;
    color: #000;
    font-size: .52rem;
  }
  .user-ul{
    display: flex;
    /* align-items: center; */
    flex-wrap: wrap;
  }
  .user-ul .user-li{
    width: calc(25% - 10px);
    margin-top: .9rem;
    text-align: center;
    margin: 0.9rem 5px;
  }
  .user-ul .user-li .icon{
    width: .82rem;
    height: .82rem;
  }
  .user-ul .user-li .text{
    margin-top: .2rem;
    color: #000;
    font-size: .42rem;
    word-break:break-all;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user.vue